export default __webpack_public_path__ + "static/media/item_arrow.027f9c11.svg";